const initialState = {
  list: {
    isLoading: false,
    isLoaded: false,
    error: '',
    data: {
      dictionaries: {
        count: 0,
        results: [],
      },
      entities: {
        count: 0,
        results: [],
      },
      intents: {
        count: 0,
        results: [],
      },
      rules: {
        count: 0,
        results: [],
      },
      matching_pattern_elements: {
        count: 0,
        results: [],
      },
      dictionary_columns: {
        count: 0,
        results: [],
      },
      entity_features: {
        count: 0,
        results: [],
      },
      constraint_sets: {
        count: 0,
        results: [],
      },
    },
    count: 0,
  },
};

export default initialState;
